"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSearchText = exports.getErrorByField = void 0;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
require("./style.scss");
var getErrorByField = function (field, addNewRecipient) {
    if (addNewRecipient.status === 'ERROR') {
        var errors = addNewRecipient.errors[field];
        if (errors) {
            return React.createElement("p", { className: 'form-error' }, errors[0]);
        }
        return undefined;
    }
    return undefined;
};
exports.getErrorByField = getErrorByField;
var getSearchText = function (isFetching) {
    return isFetching ? 'Searching company...' : 'No results found';
};
exports.getSearchText = getSearchText;
var AddNewDeliveryAddress = function (props) { return (React.createElement("div", { className: 'distribution-and-order-add-new-delivery-address' },
    React.createElement(sok_ui_1.RequestStatusBox, { status: props.addNewRecipient.status, statusList: ['INITIAL', 'SAVING', 'SAVED', 'FAILED'] },
        (0, translation_1.getLocalization)('orderAndDistribution/addNewDeliveryAddress/textSaving'),
        (0, translation_1.getLocalization)('orderAndDistribution/addNewDeliveryAddress/textSaved'),
        (0, translation_1.getLocalization)('orderAndDistribution/addNewDeliveryAddress/textErrorSaving')),
    React.createElement(sok_ui_1.Grid.Row, { className: 'company-search' },
        React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
            React.createElement("label", null,
                React.createElement(Icon_1.Icon, { className: "fa-building" }),
                ' ',
                (0, translation_1.getLocalization)('userfront/order/addressbook/company')),
            React.createElement(sok_ui_1.TextInput, { id: 'company', className: 'white', value: props.addNewRecipient.company, onChange: props.changeAddNewRecipientField('company') }),
            (0, exports.getErrorByField)('company', props.addNewRecipient)),
        React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
            React.createElement("label", { htmlFor: 'email' },
                React.createElement(Icon_1.Icon, { className: "fa-at" }),
                ' ',
                (0, translation_1.getLocalization)('userfront/order/addressbook/email')),
            React.createElement(sok_ui_1.TextInput, { id: 'email', className: 'white', value: props.addNewRecipient.email, onChange: props.changeAddNewRecipientField('email') }),
            (0, exports.getErrorByField)('email', props.addNewRecipient)),
        React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
            React.createElement("label", { htmlFor: 'first-name' },
                React.createElement(Icon_1.Icon, { className: "fa-id-card" }),
                ' ',
                (0, translation_1.getLocalization)('userfront/order/addressbook/firstName')),
            React.createElement(sok_ui_1.TextInput, { id: 'first-name', className: 'white', value: props.addNewRecipient.firstName, onChange: props.changeAddNewRecipientField('firstName') }),
            (0, exports.getErrorByField)('firstName', props.addNewRecipient)),
        React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
            React.createElement("label", { htmlFor: 'last-name' },
                React.createElement(Icon_1.Icon, { className: "fa-id-card" }),
                ' ',
                (0, translation_1.getLocalization)('userfront/order/addressbook/lastName')),
            React.createElement(sok_ui_1.TextInput, { id: 'last-name', className: 'white', value: props.addNewRecipient.lastName, onChange: props.changeAddNewRecipientField('lastName') }),
            (0, exports.getErrorByField)('lastName', props.addNewRecipient)),
        React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
            React.createElement("label", { htmlFor: 'title' },
                React.createElement(Icon_1.Icon, { className: "fa-user-graduate" }),
                ' ',
                (0, translation_1.getLocalization)('userfront/order/addressbook/title')),
            React.createElement(sok_ui_1.TextInput, { id: 'title', className: 'white', value: props.addNewRecipient.title, onChange: props.changeAddNewRecipientField('title') }),
            (0, exports.getErrorByField)('title', props.addNewRecipient)),
        React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
            React.createElement("label", { htmlFor: 'telephone' },
                React.createElement(Icon_1.Icon, { className: "fa-phone" }),
                ' ',
                (0, translation_1.getLocalization)('userfront/order/addressbook/telephone')),
            React.createElement(sok_ui_1.TextInput, { id: 'telephone', className: 'white', value: props.addNewRecipient.telephone, onChange: props.changeAddNewRecipientField('telephone') }),
            (0, exports.getErrorByField)('telephone', props.addNewRecipient)),
        React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
            React.createElement("label", { htmlFor: 'street-address' },
                React.createElement(Icon_1.Icon, { className: "fa-map-marker" }),
                ' ',
                (0, translation_1.getLocalization)('userfront/order/addressbook/street')),
            React.createElement(sok_ui_1.TextInput, { id: 'street-address', className: 'white', value: props.addNewRecipient.street, onChange: props.changeAddNewRecipientField('street') }),
            (0, exports.getErrorByField)('street', props.addNewRecipient)),
        React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
            React.createElement("label", { htmlFor: 'postal-code' },
                React.createElement(Icon_1.Icon, { className: "fa-inbox" }),
                ' ',
                (0, translation_1.getLocalization)('userfront/order/addressbook/postal')),
            React.createElement(sok_ui_1.TextInput, { id: 'postal-code', className: 'white', value: props.addNewRecipient.postalCode, onChange: props.changeAddNewRecipientField('postalCode') }),
            (0, exports.getErrorByField)('postalCode', props.addNewRecipient)),
        React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
            React.createElement("label", { htmlFor: 'city' },
                React.createElement(Icon_1.Icon, { className: "fa-building" }),
                ' ',
                (0, translation_1.getLocalization)('userfront/order/addressbook/city')),
            React.createElement(sok_ui_1.TextInput, { id: 'city', className: 'white', value: props.addNewRecipient.city, onChange: props.changeAddNewRecipientField('city') }),
            (0, exports.getErrorByField)('city', props.addNewRecipient)),
        React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
            React.createElement("label", { htmlFor: 'user-settings-country' },
                React.createElement(Icon_1.Icon, { className: "fa-building" }),
                ' ',
                (0, translation_1.getLocalization)('components/userSettingsGeneralModal/countryTitle')),
            React.createElement("select", { id: 'user-settings-country', value: props.addNewRecipient.country, onChange: props.changeAddNewRecipientField('country') },
                React.createElement("option", null),
                props.regions.map(function (r) { return (React.createElement("option", { key: r.code, value: r.code }, r.name)); })),
            (0, exports.getErrorByField)('country', props.addNewRecipient))),
    !props.hideControls && (React.createElement("div", { className: 'add-new-delivery-address-form-buttons' },
        React.createElement(sok_ui_1.Button, { onClick: props.currentFolder &&
                props.createNewExternalUser(props.currentFolder, props.addNewRecipient), color: 'base-green', size: 'large', text: (0, translation_1.getLocalization)('userfront/order/addressbook/save') }),
        React.createElement(sok_ui_1.Button, { onClick: props.clearAddNewRecipient, color: 'dark-gray', size: 'large', text: (0, translation_1.getLocalization)('userfront/order/addressbook/cancel') }))))); };
exports.default = AddNewDeliveryAddress;
